import instance from "@/services/api";

export const techprojectRequestsAPI = {
  async getList(params) {
    return await instance()
      .get(`/client_request/techproject_requests/read/`, {params})
      .then((res) => res?.data);
  },
};
